// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function G17Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 60 41"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M23.434 40.743L35.36 27.812 23.434 14.879h12.583l5.906 6.282 5.688-6.282h12.144l-11.87 12.88 12.033 12.984H47.283l-5.853-6.334-5.797 6.334H23.434zm0-31.662H9.927v5.798h13.507v8.738H9.927v8.02h13.507v9.106H0V0h23.434v9.081z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default G17Icon
/* prettier-ignore-end */
